import { EntityType } from '../services/entities/entity-type.class';
import { Entity } from './entity.class';
import { Planning } from './planning.class';

export class PlanningProjectteam {
    entitytype_key: string;
    entity_id: number;
    planning_id: number;
    driver_user_id: number;
    entitytype?: EntityType;
    truck_entity_id: number;
    lowloader_entity_id: number;
    begindate: Date;
    enddate: Date;
    name: string;
    comment: string;
    created_at: Date;
    updated_at: Date;
    id: number;
    count: number;
    hiring_id: number;
    entity: Entity;
    planning: Planning;
    origin: string;
    destination: string;
}
